import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: '',
          component: () => import('@/views/pages/Login'),
        },          
      ],
    },
    {
      path: '/',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Crear Usuario',
          path: 'pages/usuarioCrear',
          component: () => import('@/views/pages/UsuarioCrear'),
        },          
      ],
    },
    {
      path: '/',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Olvide Contrasena',
          path: 'pages/usuarioOlvidoContrasena',
          component: () => import('@/views/pages/UsuarioOlvidoContrasena'),
        },          
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Dashboard
        {
          name: 'Dashboard',
          path: 'dashboard',
          component: () => import('@/views/dashboard/Dashboard'),
        },
        // Components mascotas 
        // Components  UsuarioMascota
        {
          name: 'DetallePorSensor',
          path: 'components/DetallePorSensor',
          component: () => import('@/views/dashboard/component/DetallePorSensor'), 
        },   
        {
          name: 'Mascota',
          path: 'components/Mascota',
          component: () => import('@/views/dashboard/component/Mascota'), 
        },   
        {
          name: 'Agenda',
          path: 'components/Agenda',
          component: () => import('@/views/dashboard/component/Agenda'), 
        },   
        {
          name: 'Grupo',
          path: 'components/grupo',
          component: () => import('@/views/dashboard/component/Grupo'), 
        },    
        {
          name: 'Sensor',
          path: 'components/sensor',
          component: () => import('@/views/dashboard/component/Sensor'), 
        },    
        {
          name: 'Urbanización',
          path: 'components/urbanizacion',
          component: () => import('@/views/dashboard/component/Urbanizacion'), 
        },   
        {
          name: 'Edificio',
          path: 'components/edificio',
          component: () => import('@/views/dashboard/component/Edificio'), 
        },     
        {
          name: 'Propiedad',
          path: 'components/propiedad',
          component: () => import('@/views/dashboard/component/Propiedad'), 
        },    
        {
          name: 'GenerarFactura',
          path: 'components/GenerarFactura',
          component: () => import('@/views/dashboard/component/GenerarFactura'), 
        },    
        {
          name: 'RegistroPago',
          path: 'components/RegistroPago',
          component: () => import('@/views/dashboard/component/RegistroPago'), 
        },    
         {
          name: 'RegistroPagoBot',
          path: 'components/RegistroPagoBot',
          component: () => import('@/views/dashboard/component/RegistroPagoBot'), 
        },   
        {
          name: 'EstadoCuenta',
          path: 'components/EstadoCuenta',
          component: () => import('@/views/dashboard/component/EstadoCuenta'), 
        },    
        {
          name: 'Test',
          path: 'components/test',
          component: () => import('@/views/dashboard/component/test'), 
        },   
        {
          name: 'Consolidador',
          path: 'components/Consolidador',
          component: () => import('@/views/dashboard/component/Consolidador'), 
        },   
        {
          name: 'Proveedor',
          path: 'components/Proveedor',
          component: () => import('@/views/dashboard/component/Proveedor'), 
        },   
          {
          name: 'CuentasPorPagar',
          path: 'components/CuentasPorPagar',
          component: () => import('@/views/dashboard/component/CuentasPorPagar'), 
        },   
          {
          name: 'Balance',
          path: 'components/Balance',
          component: () => import('@/views/dashboard/component/Balance'), 
        },   
      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})
